import { render, staticRenderFns } from "./InsertOptionProduct.vue?vue&type=template&id=273b8fa0&scoped=true"
import script from "./InsertOptionProduct.vue?vue&type=script&lang=js"
export * from "./InsertOptionProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b8fa0",
  null
  
)

export default component.exports